import {App, getCurrentInstance} from "vue";

/**
 *
 * @param arr 目标数组
 * @param value 枚举值
 * @param targetKey 查找对应的key
 * @param returnKey 需要返回的key
 * 示例： arr: [{name: 'a', value: 1}, {name: 'b', value: 2}]
 *      value  2
 *      targetKey   value
 *      returnKey name
 *
 *
 */
const valueToName = (arr: [], value: number|string , targetKey: string, returnKey: string) => {
  for (const arrElement of arr) {
      if (arrElement[targetKey] == value) {
          return arrElement[returnKey];
      }
  }
}


const getSuffix = (name: string = '', tag = '.') => {
   return name.substring(name.lastIndexOf(tag)+1)
}



export function setupFilter(app: App) {
  app.config.globalProperties.$valueToName = valueToName //匹配枚举字段
  app.config.globalProperties.$getSuffix = getSuffix //获取分隔符最后一次出现位置后面的字符串

}


